import { Component, OnDestroy, signal, ViewChild, WritableSignal, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { ActivatedRoute, Router } from '@angular/router';
import { UpdatePageTitle } from '../../../../store/app/app.actions';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { FundAccountApiService } from '../../../../_services/fund-account-service/fund-account-api.service';
import { FundAccountInfo } from '../../../../_interfaces/fund-account.interface';
import { InfoBlockComponent } from '../../../../shared/components/info-card-block/info-block.component';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { FundAccountBalanceWidgetComponent } from '../_components/fund-account-balance-widget/fund-account-balance-widget.component';
import { AccountBalanceWidget } from '../../../../_interfaces/dashboard.interface';
import { Subscription } from 'rxjs';
import { BankingStatus } from '../../../../_interfaces/business.interface';

@Component({
  selector: 'app-fund-account',
  imports: [
    InfoBlockComponent,
    LoaderComponent,
    NgClass,
    NgbCollapse,
    FundAccountBalanceWidgetComponent,
    NgTemplateOutlet,
  ],
  templateUrl: './fund-account.component.html',
})
export class FundAccountComponent implements OnDestroy {
  readonly store = inject(Store);
  readonly router = inject(Router);
  readonly route = inject(ActivatedRoute);
  readonly fundAccountApiService = inject(FundAccountApiService);

  @ViewChild('EmpCardCollapse') empCardCollapse!: NgbCollapse;
  @ViewChild('SubCardCollapse') subCardCollapse!: NgbCollapse;
  subscriptions = new Subscription();

  fundAccountDetails = signal<FundAccountInfo | undefined>(undefined);
  protected isEmpCardsCollapsed = false;
  protected isSubCardsCollapsed = true;

  displayData = signal<AccountBalanceWidget | undefined>(undefined);

  isLoading: WritableSignal<boolean> = signal(true);

  constructor() {
    this.store.dispatch(new UpdatePageTitle('Fund account'));
    this.getFundAccountDetails();
  }

  onOpenEmpCards() {
    this.empCardCollapse.toggle();
    this.isSubCardsCollapsed = true;
  }

  onOpenSubCards() {
    this.subCardCollapse.toggle();
    this.isEmpCardsCollapsed = true;
  }

  getFundAccountDetails() {
    this.subscriptions.add(
      this.fundAccountApiService.getFundAccountInfo().subscribe({
        next: (res) => {
          this.fundAccountDetails.set(res);
          this.displayData.set({
            balance_physical_cards: '',
            balance_virtual_cards: '',
            total_physical: '',
            total_virtual: '',
            balance_virtual: res.virtual_balance,
            balance_physical: res.physical_balance,
          });
          this.isLoading.set(false);
        },
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  protected readonly bankingStatus = BankingStatus;
}
